import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  IGlobalHbUserState,
  selectConfiguration,
  selectHbContacts,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ListingsListPage from '../components/ListingsListPage'
import {
  actionCreators,
  IListingsListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectOrderBy,
  selectListingtype,
  selectOnlyNoPhotos,
  selectPrimaryAgent,
  selectPropertyTypes,
  selectScope,
  selectSortOrder,
  selectStatus,
  selectTotalItems,
} from '../modules/listingsList'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IListingsListState & IGlobalConfigurationState & IGlobalHbUserState
    >({
      configuration: selectConfiguration(),
      error: selectError(),
      filterText: selectFilterText(),
      hbContacts: selectHbContacts(),
      isLoading: selectIsLoading(),
      items: selectItems(),
      listingType: selectListingtype(),
      onlyNoPhotos: selectOnlyNoPhotos(),
      primaryAgent: selectPrimaryAgent(),
      propertyTypes: selectPropertyTypes(),
      scope: selectScope(),
      sortOrder: selectSortOrder(),
      orderBy: selectOrderBy(),
      status: selectStatus(),
      totalItems: selectTotalItems(),
    }),
    actionCreators,
  )(ListingsListPage),
)
